export function totalFromGetUnreadNumRow(row = {}) {
    const nameCard =
        row.nameCardNums ??
        row.nameCardNum ??
        row.nameCard ??
        row.nameCardUnread ??
        row.nameCardUnreadNums ??
        0;
    const inquiry = Number(row.direct ?? 0) || 0;
    const nameCardN = Number(nameCard) || 0;
    const likeFollow = Number(row.likeFollowNums ?? row.likeFollowNum ?? 0) || 0;
    const sourcingMatched = Number(row.sourcingRequestsNums ?? 0) || 0;
    const sourcingApplied = Number(row.sourcingContactBuyerFormNums ?? 0) || 0;
    return inquiry + nameCardN + likeFollow + sourcingMatched + sourcingApplied;
}

export function totalFromSalesLeadTypeData(typeData) {
    if (!typeData || !typeData.length) return 0;
    return (
        (Number(typeData[1]?.Nums) || 0) +
        (Number(typeData[2]?.Nums) || 0) +
        (Number(typeData[3]?.Nums) || 0) +
        (Number(typeData[4]?.Nums) || 0)
    );
}
